import { BaseMemberProps } from "@custom-types/member-types";
import { blue, Chip, yellow } from "@flat-ui";
import { getMemberStatus, isMemberActive } from "@utils/user-utils";
import { useMemo } from "react";

/**
 * Returns the registration status of a team member as a chip
 * If the identity is equal to id, then the user is registered and active
 */
export function MemberStatus({ member }: BaseMemberProps): JSX.Element {
  const statusChipProps = useMemo(() => {
    return isMemberActive(member)
      ? {
          label: getMemberStatus({ member }),
          color: blue[500],
          backgroundColor: blue[100],
          tooltip: "The invited member successfully created an account",
        }
      : {
          label: getMemberStatus({ member }),
          color: yellow[600],
          backgroundColor: yellow[50],
          tooltip: "The invited member has not yet created an account",
        };
  }, [member]);

  return <Chip {...statusChipProps} />;
}
